import {gsap} from "gsap";
import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../../core/winpresentation/SimplePresentationRunner";
import {TheCrypt} from "../../TheCrypt";
import {APISetting} from "@nolimitcity/slot-launcher/bin/interfaces/APISettingsSystem";
import {ScatterCounter} from "../../view/ScatterCounter";

export class FillUpPresentation implements SimplePresentation {
    name: string = "FillUpPresentation";

    shouldRun(): boolean {
        return true;
    }

    start(controller: SimplePresentationRunnerController): void {
        const tl: gsap.core.Timeline = gsap.timeline({onComplete: () => controller.finish()});
        tl.add(() => controller.setSkipCallback(() =>{
            tl.timeScale(3);
        }));
        tl.add(TheCrypt.realArea.fillUp());
        tl.add(()=>TheCrypt.reelAnticipation.fadeOutAnticipationSound());
        if(ScatterCounter.allScatters.length>=2){
            TheCrypt.reelAnticipation.update(0);
        }
        tl.to(this, {duration: 0.01});
        if (TheCrypt.apiPlugin.settings.get(APISetting.FAST_SPIN)) {
            tl.timeScale(1.4);
        }
    }
}